import { Country } from '~/Api/Country';

import VirtualPackReimbursement from './VirtualPackReimbursement';

export default class Reimbursement {
	country: Country;

	brandName: string;

	virtualPacks: VirtualPackReimbursement[];

	constructor(country: Country, brandName: string, virtualPacks: VirtualPackReimbursement[]) {
		this.country = country;
		this.brandName = brandName;
		this.virtualPacks = virtualPacks;
	}

	groupVirtualPacks(): VirtualPackReimbursement[][] {
		return this.virtualPacks.reduce<VirtualPackReimbursement[][]>((groups, virtualPack) => {
			const sameGroup = groups.find((group) => group[0]?.hasSimilarSentences(virtualPack.sentences));
			if (sameGroup !== undefined) {
				sameGroup.push(virtualPack);
			} else {
				groups.push([virtualPack]);
			}
			return groups;
		}, []);
	}
}
